import React, { useState, useEffect } from 'react';
import './Navigation.css';
import visionProImage from '../assets/images/logo greenerTech.png';
import ContactModal from './ContactModal'; 

// --- NOUVELLES ICÔNES ---
const MenuIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 6H20M4 12H20M4 18H20" stroke="#b0b0b0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
const CloseIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="#b0b0b0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);


const Navigation = () => {
    const [scrolled, setScrolled] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false); 
    // NOUVEL ÉTAT : Gestion du menu mobile
    const [isMenuOpen, setIsMenuOpen] = useState(false); 

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        
        // Bloque le défilement du corps lorsque le menu est ouvert
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.body.style.overflow = 'auto'; // S'assurer que le défilement est rétabli au nettoyage
        };
    }, [isMenuOpen]);

    const handleLinkClick = () => {
        setIsMenuOpen(false); // Ferme le menu après un clic sur un lien
        // Ferme également le modal si un lien est cliqué
        setIsModalOpen(false); 
    };

    return (
        <>
            <nav className={`navigation ${scrolled ? 'scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
                <div className="nav-container">
                    {/* Logo (Identique) */}
                    <div className="nav-logo">
                        <img 
                            src={visionProImage}
                            alt="ROBOMAT Logo"
                            className="vision-pro-image"
                            loading="lazy"
                        />
                    </div>

                    {/* Liens de navigation (Utilisés pour le bureau et le menu mobile) */}
                    <ul 
                        className={`nav-links ${isMenuOpen ? 'nav-links-mobile' : ''}`}
                    >
                        <li><a href="#home" onClick={handleLinkClick}>ACCUEIL</a></li>
                        <li><a href="#features" onClick={handleLinkClick}>FONCTIONNALITÉS</a></li>
                        <li><a href="#design" onClick={handleLinkClick}>DESIGN</a></li>
                        <li><a href="#demo" onClick={handleLinkClick}>DÉMO</a></li>
                        <li><a href="#visionos" onClick={handleLinkClick}>VISIONS</a></li>
                        
                        {/* Bouton de notification sur le menu mobile */}
                        <li className="nav-notify-mobile-item">
                            <button 
                                className="nav-notify"
                                onClick={() => { handleLinkClick(); setIsModalOpen(true); }}
                            >
                                Prévenez-moi
                            </button>
                        </li>
                    </ul>

                    {/* Bouton Notify Me (Desktop) */}
                    <button 
                        className="nav-notify nav-notify-desktop"
                        onClick={() => setIsModalOpen(true)}
                    >
                        Prévenez-moi
                    </button>
                    
                    {/* Bouton du menu BURGER (Visible uniquement sur mobile) */}
                    <button 
                        className="nav-toggle-btn"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        aria-label={isMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
                    >
                        {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
                    </button>
                </div>
            </nav>
            
            {/* Modal de contact */}
            <ContactModal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
            />
        </>
    );
};

export default Navigation;